export enum ScriptType {
  Transformation = 1,
  Query = 2,
}

export enum InputType {
  JSON = 1,
}

export const InputTypeNames: Record<InputType, string> = {
  [InputType.JSON]: 'JSON',
};

export interface Script {
  id: string;
  name: string;
  description: string;
  endpointTypeId: number;
  endpointSubtypeIds: number[];
  inputTypeId: InputType;
  javascriptCode: string;
  sampleData?: string;
  lastModifiedDate: string | null;
  isActive?: boolean;
}

export interface EndpointSubtypeOption {
  id: number;
  name: string;
}

export interface EndpointTypeOption {
  id: number;
  name: string;
  subtypes: EndpointSubtypeOption[];
}

export interface FetchScriptsParams {
  pageNumber?: number;
  pageSize?: number;
  orderBy?: string;
  orderByDesc?: boolean;
  search?: string;
  endpointTypeId?: number | '';
  endpointSubtypeId?: number | '';
  inputTypeId?: InputType | '';
}

export interface ScriptRunPayload {
  options: {
    isConsoleOutputEnabled: boolean;
  };
  data: string;
}

export interface ScriptTestItem {
  id: string;
  name: string;
  scriptId: string;
  scriptName: string;
  sample: string;
  target: string;
  output?: string;
  validationMessage?: string;
  status?: 'pending' | 'running' | 'pass' | 'fail';
}

export const getDefaultScript = (): Omit<Script, 'id'> => ({
  name: '',
  description: '',
  endpointTypeId: 0,
  endpointSubtypeIds: [],
  inputTypeId: InputType.JSON,
  javascriptCode: '',
  sampleData: '{}',
  lastModifiedDate: null,
});

export const enum RunButtonState {
  Run = 'Run',
  Running = 'Running',
  Success = 'Success',
  Error = 'Error',
}

export type FormState = {
  name: string;
  description: string;
  javascriptCode: string;
  sampleData: string;
  endpointTypeId: number;
  endpointSubtypeIds: number[];
  inputTypeId: InputType;
};
